import { createSlice } from '@reduxjs/toolkit'
import { REFRESH_STATE } from '../utils/refreshManager'

/**
 * UI Slice
 * Manages UI-specific state like focus mode, modals, etc.
 * Does NOT persist to database - session-only state
 */

const initialState = {
  isInFocusMode: false,
  preFullscreenTheme: null, // Store original theme to restore on exit
  // Single source of truth for refresh state (replaces isRefreshingData + isPendingRefresh)
  refreshState: REFRESH_STATE.IDLE,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    enterFocusMode: (state, action) => {
      state.isInFocusMode = true
      state.preFullscreenTheme = action.payload // Store current theme
    },
    exitFocusMode: (state) => {
      state.isInFocusMode = false
      state.preFullscreenTheme = null
    },
    setRefreshState: (state, action) => {
      state.refreshState = action.payload
    },
    clearUI: () => initialState,
  },
})

export const { enterFocusMode, exitFocusMode, setRefreshState, clearUI } = uiSlice.actions

// Selectors
export const selectRefreshState = (state) => state.ui.refreshState
export const selectIsRefreshing = (state) => state.ui.refreshState === REFRESH_STATE.REFRESHING

// Extract array constant to avoid creating new array on every selector call
const PENDING_REFRESH_STATES = [REFRESH_STATE.WAITING_FOR_NETWORK, REFRESH_STATE.DEBOUNCING]
export const selectIsPendingRefresh = (state) =>
  PENDING_REFRESH_STATES.includes(state.ui.refreshState)

export default uiSlice.reducer
